import { render, staticRenderFns } from "./DocumentStorageWidget.vue?vue&type=template&id=3bc53c22&scoped=true&"
import script from "./DocumentStorageWidget.vue?vue&type=script&lang=js&"
export * from "./DocumentStorageWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc53c22",
  null
  
)

export default component.exports